export const SEARCH_FORM_FOCUS_HASH = "#search-focus";
export const SEARCH_FORM_FOCUS_HASH = "#search-focus";
